/**
 * Validates an OnClick trigger CSS selector string.
 * Returns an empty string if valid, or the validation error message if invalid.
 *
 * @param selector - The CSS selector string to validate
 * @param validationErrorTranslation - The translation key for the validation error message
 * @returns Empty string if valid, error message if invalid
 */
export const validateOnClickSelector = (selector: string, validationErrorTranslation: string): string => {
  if (!selector.trim()) {
    return '';
  }

  const trimmedSelector = selector.trim();

  const invalidPatterns = [
    /^\s*$/, // Empty or whitespace only
    /[<>]/, // HTML tags
    /[{}]/, // Curly braces
    /[()]/, // Parentheses (unless part of pseudo-selectors)
    // eslint-disable-next-line no-useless-escape
    /^[^.#a-zA-Z\\[]/, // Doesn't start with valid characters
    // eslint-disable-next-line no-useless-escape
    /[^.#a-zA-Z0-9_\-\[\]="'`\s,]/, // Contains invalid characters
  ];

  const isInvalid = invalidPatterns.some(pattern => pattern.test(trimmedSelector));

  if (isInvalid) {
    return validationErrorTranslation;
  }

  return '';
};
